import React, { Component, useEffect, useRef, useState } from "react";

import { Link,NavLink, useNavigate } from "react-router-dom";
import logo from '../images/logo.png';

import burger from '../images/burger.png';
import crosss from '../images/crosss.png';
import { Tooltip } from "reactstrap";
import axios from "axios";
import { API_URL } from "../../config";
import MobileMenu from "./home/MobileMenu";


function Top() {
//   const params = new URLSearchParams(window.location.search);
//       const token = params.get("accessToken");

      
//      const fetchUserByUserId = async () => {
//   try {
//     const res = await axios.get(`${API_URL}/distributor/me`, {
//       headers: {
//         "x-access-token": token
//       },
//     });
//        localStorage.setItem('user_id', data.user_id);
//             localStorage.setItem('accessToken', data.accessToken);
//               localStorage.setItem('user_type', data.data[0].user_type);
//             localStorage.setItem('uid', data.data[0].uid);
//             localStorage.setItem('user_name', data.data[0].firstname + " "+ data.data[0].lastname);
//     return res.data;
//   } catch (err) {
//     console.error("Error fetching distributor:", err.response?.data || err.message);
//   }
// };
// useEffect(()=>{
// if(token){
//     fetchUserByUserId()
// }
// },[token])
  
    const auth = localStorage.getItem('user_id');
    const navigation = useNavigate();
    const id =  localStorage.getItem("uid");
    const user_type =  localStorage.getItem("user_type");
    const user_name =  localStorage.getItem("user_name");




    const TabArray = [
     
      {
        links: "/", name: "Devices", icon: <i className="fa-solid fa-list-check"></i>
      },
      {
        links: "/distributors", name: "Distributors", icon: <i className="fas fa-user-friends"></i>
      },
      {
        links: "/customers", name: "Customers", icon: <i className="fa fa-users"></i>
      },
      {
        links: "/software-update", name: "Software Updates", icon: <i className="fa fa-gear"></i>
      },
      {
        links: "/software-announcement", name: "Software Announcements", icon: <i className="fa fa-bullhorn"></i>
      },
      {
        links: "/recordings", name: "Recordings", icon: <i className="fas fa-microphone"></i>
      },
      {
        links: "/tutorial-recordings", name: "Tutorial Recordings", icon: <i className="fas fa-video"></i>
      },
      {
        links: "/announcements", name: "Email Announcement", icon: <i className="fa-solid fa-envelope-open-text"></i>
      },
      {
        links: `/edit/distributor/${id}`, name: "Edit Profile", icon: <i className="fa-solid fa-edit"></i>
      },      
    ]
    const TabArray6 = [
     
      {
        links: "/", name: "Devices", icon: <i className="fa-solid fa-list-check"></i>
      },
      // {
      //   links: "/distributors", name: "Distributors", icon: <i className="fa-solid fa-list-check"></i>
      // },
      {
        links: "/customers", name: "Customers", icon: <i className="fa fa-users"></i>
      },
      // {
      //   links: "/software-update", name: "Software Updates", icon: <i className="fa-solid fa-list-check"></i>
      // },
      {
        links: "/recordings", name: "Recordings", icon: <i className="fas fa-microphone"></i>
      },
      // {
      //   links: "/maintenance2", name: "Tutorial Recordings", icon: <i className="fas fa-video"></i>
      // },
      // {
      //   links: "/maintenance5", name: "Announcements", icon: <i className="fa-solid fa-list-check"></i>
      // },
      {
        links: `/edit/distributor/${id}`, name: "Edit Profile", icon: <i className="fa-solid fa-edit"></i>
      },      
    ]

    useEffect(() => {
        changePickupStoreMenu();

    function changePickupStoreMenu() {

      var body = $('body'),
        mask = $('<div className="mask"></div>'),
        toggleSlideRight = document.querySelector(".toggle-slide-right"),
        slideMenuRight = document.querySelector(".slide-menu-right"),
        activeNav = '';
      ;
      $('body').append(mask);

      /* slide menu right */
      toggleSlideRight.addEventListener("click", function () {
        $('body').addClass("smr-open");
        $('.mask').fadeIn();
        activeNav = "smr-open";
      });

      /* hide active menu if close menu button is clicked */
      $(document).on('click', ".close-menu", function (el, i) {
        $('body').removeClass(activeNav);
        activeNav = "";
        $('.mask').fadeOut();
      });

    }
    }, [])


    const handleActive = (link) =>{
      navigation(`${link}`)
    }

    const logout = () => {
        localStorage.clear();
        navigation('/login');
    }
    const handleEditProfile = (event)=>{
      // event.preventDefault();
      if(user_type=7){
        navigation("/edit/tech-support/" + `${id}`);
        
      }else{
        navigation("/edit/distributor/" + `${id}`);
      }
      
    }


    return (
        <div>
            <div className='db-hding'>
                <div className="logo">
                    {/* <Link to="/">
                        <img src={logo}></img>
                        </Link> */}
                </div>
                <h3>{user_type == 7 ?"BETTER PHYSIOLOGY DASHBOARD":"DISTRIBUTOR DASHBOARD"}</h3>
                <NavLink to={"javascript:void"} style={{color:'white'}}> 
               {user_type == 6 && <>
                  
                <i className="fa fa-user-alt" aria-hidden="true" style={{marginLeft:"10px"}}></i> <span className="hover-container" >{user_name}
                <div className="hover-popup">{user_type == 6 ? "Name of distributor" : "Name of admin"}</div>
                </span>
                </>}
               {user_type==6 && <>
                  <i className="fa fa-edit" aria-hidden="true" onClick={(event)=>handleEditProfile(event)} style={{marginLeft:"10px"}}></i> <span onClick={handleEditProfile} className="span-top">Edit Profile</span> 
                </>}
                {/* <i className="fa fa-sign-out" aria-hidden="true" onClick={logout} style={{marginLeft:"10px"}}></i> <span onClick={logout}>Logout</span> */}
                </NavLink>

                    
            </div>


            {/* mobile */}

            <div className="border-b">
      <div className="container-fluid">
        <div className="header-box">
          <div className="header-c1">
            {/* <div className="logo-box">
              <a href="/">
                <img src={logo} />
              </a>
            </div> */}
            <p>{user_type == 7 ?"BETTER PHYSIOLOGY DASHBOARD":"DISTRIBUTOR DASHBOARD"}</p>
          </div>


          <div className="header-c2">
            
            <div className="burger-area">
              <a href="#javascript:void(0)" className="burgers toggle-slide-right"> <img src={burger} /></a>
            </div>
          </div>

        </div>

        <div className="menu slide-menu-right menu-list-wrp">
          <button className="close-menu"><img src={crosss} className="img-close" /></button>
          {/* <ul className="menu-list2">

            <li>
              <ul className='l-sideb-list'>
                {
                  user_type == 7 ?   (
                    TabArray.map((val, index) => {
                      return (
                        <li>
                          <NavLink to={val.links} key={index} onClick={() => handleActive(index, val.links)}>
                            {val.icon}
                            <span>{val.name}</span>
                          </NavLink>
                        </li>
                      )
                    })
                  )                   
                  :   (
                    TabArray6.map((val, index) => {
                      return (
                        <li>
                          <NavLink to={val.links} key={index} onClick={() => handleActive(index, val.links)}>
                            {val.icon}
                            <span>{val.name}</span>
                          </NavLink>
                        </li>
                      )
                    })
                  )
                }
                <li>
                    {
                        auth ? <NavLink to='/login' className="close-menu" onClick={logout}> <i className="fa fa-sign-out" aria-hidden="true"></i> <span>Logout</span></NavLink> : null

                    }
                    </li>
                    

              </ul>
            </li>
          </ul> */}
          <MobileMenu/>
        </div>

      </div>

      
    </div>
        </div>
    )
}


export default Top;